<template>
  <avue-crud
    :option="tableConfig"
    :data="planList"
    v-model="tableForm"
    :page.sync="page"
  >
    <template slot="menuRight">
      <!-- <el-button type="primary" size="small" icon="el-icon-plus"
                      >导入自定义计划
                    </el-button> -->
      <el-button
        type="primary"
        @click="add"
        v-if="editType"
        size="small"
        icon="el-icon-plus"
        >新增
      </el-button>
      <!-- <el-button
        v-if="editType"
        size="small"
        @click="editType = false"
        >取消
      </el-button> -->
      <el-button
        v-if="permission.factoringQuotaSchemeList_edit"
        :loading="loading"
        size="small"
        :disabled="isShow()"
        :icon="editType ? 'el-icon-s-claim' : 'el-icon-edit'"
        :type="editType ? '' : 'primary'"
        @click="editType ? submit() : handleEdit(true)"
        >{{ editType ? "保存" : "编辑" }}</el-button
      >

      <!-- <el-button size="small" plain>导出 </el-button>
                    <el-button size="small" plain>打印 </el-button> -->
    </template>
    <template slot-scope="{ row }" slot="menuLabel">
      <div class="del_color" >
        <i @click="del(row.$index)"  class="el-icon-delete-solid"></i>
        <!-- <i @click="add(row.$index)"  class="el-icon-circle-plus-outline"></i> -->
      </div>
    </template>

    <template slot="rentDay" slot-scope="{ row }">
      <el-date-picker
        v-model="row.rentDay"
        type="date"
        placeholder="选择日期"
        v-if="editType"
        format="yyyy-MM-dd"
        value-format="yyyyMMdd"
        :clearable="false"
      >
      </el-date-picker>

      <div v-else>
        {{ dateConvert(row.rentDay) }}
      </div>
    </template>

    <template slot="expectedRent" slot-scope="{ row }">
      <el-input-number
        :controls="false"
        v-model="row.expectedRent"
        placeholder="请输入金额"
        v-if="editType"
        :min="0"
      ></el-input-number>
      <div v-else>
        {{ getMoney(row.expectedRent) }}
      </div>
    </template>
    <template slot="principal" slot-scope="{ row }">
      <div class="mini_size">
        <el-input-number
          :controls="false"
          v-model="row.principal"
          placeholder="请输入金额"
          v-if="editType"
          :min="0"
        ></el-input-number>
        <div v-else>
          {{ getMoney(row.principal) }}
        </div>
      </div>
    </template>
    <template slot="interest" slot-scope="{ row }">
      <el-input-number
        :controls="false"
        v-model="row.interest"
        placeholder="请输入金额"
        v-if="editType"
        :min="0"
      ></el-input-number>
      <div v-else>
        {{ getMoney(row.interest) }}
      </div>
    </template>
    <template slot="residualPrincipal" slot-scope="{ row }">
      <el-input-number
        :controls="false"
        v-model="row.residualPrincipal"
        placeholder="请输入金额"
        v-if="editType"
        :min="0"
      ></el-input-number>
      <div v-else>
        {{ getMoney(row.residualPrincipal) }}
      </div>
    </template>
    <template slot="cashFlow" slot-scope="{ row }">
      <el-input-number
        :controls="false"
        v-model="row.cashFlow"
        placeholder="请输入金额"
        v-if="editType"
        :min="0"
      ></el-input-number>
      <div v-else>
        {{ getMoney(row.cashFlow) }}
      </div>
    </template>
  </avue-crud>
</template>

<script>
import { calculateOption, tableConfig } from "../config";
import * as api from "@/api/factoring/factoringScheme";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "calcCrud",
  components: {},
  data() {
    return {
      calculateForm: {},
      calculateOption: calculateOption(),
      tableConfig: tableConfig(),
      planList: [],
      tableForm: {},
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      editType: false,
    };
  },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    dataInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    id: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    ...mapGetters(["userInfo",'permission']),
    isShow() {
      return function () {
        return this.readOnly || this.dataInfo.isLocked == 1;
      };
    },
  },
  watch: {
    tableData: {
      deep: true,
      handler(newName, oldName) {
        this.planList = newName.map((item) => {
          return {
            ...item,
            rentDay: item.rentDay + "",
          };
        });
      },
    },
  },
  methods: {
    moment,
    dateConvert(val) {
      val = (val + "").replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3");

      return val;
    },

    editOverHidden(type) {
      this.tableConfig.column.filter((item) => {
        if (item.prop === "rentDay" || item.prop === "principal") {
          item.overHidden = type;
        }
        if (item.prop === "menuLabel") {
          item.hide = type;
        }
      });
    },
    //修改
    handleEdit(type) {
      this.editType = type;
      this.editOverHidden(!type);
    },

    //调用提交方法
    submit() {
      // this.editOverHidden(true);
      let planList = this.planList.map((item) => {
        return {
          ...item,
          rentDay: Number(item.rentDay),
        };
      });

      this.$emit("submitPlan", planList);
      // let data = {
      //   ...this.dataInfo,
      //   id: this.id,
      //   planList: planList,
      // };
      // api.calcQuota(data).then(
      //   (res) => {
      //     this.$message({
      //       type: "success",
      //       message: "操作成功!",
      //     });
      //     this.editType = false;
      //     this.$emit("submitPlan", res.data.data);
      //   },
      //   (error) => {
      //     window.console.log(error);
      //   }
      // );

      // this.$emit("submitPlan", this.planList);
    },
    del(index) {
      this.$confirm("是否删除此条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.planList.splice(index, 1);
      });
    },
    add() {
      this.planList.push({
        issue:
          this.planList.length > 0
            ? this.planList[this.planList.length - 1]["issue"] + 1
            : 1,
        rentDay: undefined,
        expectedRent: 0,
        principal: 0,
        interest: 0,
        residualPrincipal: 0,
        cashFlow: 0,
      });
    },
  },
};
</script>
<style scoped lang="scss">
/deep/ .el-input-number {
  padding-left: 3px !important;
  padding-right: 0px !important;
  font-size: 10px !important;
  width: 100% !important;
}
/deep/ .el-input input {
  padding-left: 3px !important;
  padding-right: 0px !important;
  font-size: 10px !important;
}
/deep/ .el-input__prefix {
  display: none;
}
/deep/ .el-table .cell {
  padding-left: 2px !important;
}
</style>

